import InternalRequestStatusHint from 'domains/internal-request/components/internal-request-status-hint'
import OutboundInternalRequestsApiV2 from 'api/v2/admins/outbound-internal-requests-api-v2'
import { getInternalRequestListUrlState, syncInternalRequestListUrl } from 'domains/internal-request/services/internal-request-list-url-state'
import TitlePage from 'components/atoms/title-page'
import InternalRequestTable from 'domains/internal-request/organisms/table'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import {
  Card,
  CardBody
} from 'reactstrap'
import { INBOUND_STATUS } from 'domains/internal-request/constants'


const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const InternalRequestListInboundOpsPage = ({ pageUtils }) => {
  const [ internalRequests, setInternalRequests ] = useState([])
  const [ pagination, setPagination ]             = useState({})
  const [ isLoading, setIsLoading ]               = useState(false)

  const history = useHistory()
  const location = useLocation()
  const initialUrlState = getInternalRequestListUrlState(location.search)
  const initialFilters = initialUrlState.filters.some((filter) => filter.id === 'status') ?
    initialUrlState.filters :
    [ ...initialUrlState.filters, { id: 'status', value: [ INBOUND_STATUS.ONGOING ] } ]

  const handleFetchInventories = (tableState) => {
    syncInternalRequestListUrl({
      history,
      pathname      : window.location.pathname,
      currentSearch : window.location.search,
      tableState
    })

    setIsLoading(true)
    let additionalFilters = {}

    /**
     * We check whether user has been filtering by status columns.
     * if so, we don't need to use `additionalFilter`
     */
    const statusFilter = tableState.filters.find((filter) => filter.id === 'status')

    if (!statusFilter || statusFilter?.value?.length === 0) {
      additionalFilters = {
        status: [ INBOUND_STATUS.ONGOING ]
      }
    }
    OutboundInternalRequestsApiV2.index({ tableState, additionalFilters })
      .then((response) => {
        setInternalRequests(response.data.internal_requests)
        setPagination(response.data.meta)
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
      .finally(() => setIsLoading(false))
  }

  // Goes to Inventory Detail Page when clicking on the row button
  const handleSelectRow = useCallback((datum) => {
    const id = datum.id
    history.push({
      pathname: `${id}`
    })
  }, [ history ])

  return (
    <>
      <TitlePage mainTitle={ 'Ops Internal Requests List' } />

      <Card>
        <CardBody>
          <InternalRequestStatusHint audience='inbound' />
          <InternalRequestTable
            data={ internalRequests }
            pagination={ pagination }
            isLoading={ isLoading }
            initialFilter={ initialFilters }
            initialPageIndex={ initialUrlState.pageIndex }
            initialPageSize={ initialUrlState.pageSize }
            categoryStatus={ INBOUND_STATUS }
            rowButtonProps={{
              buttonText    : 'Receive Items',
              buttonColour  : 'primary',
              onButtonClick : handleSelectRow
            }}
            onFetchData={ handleFetchInventories }
          />
        </CardBody>
      </Card>
    </>
  )
}

InternalRequestListInboundOpsPage.propTypes = propTypes

export default InternalRequestListInboundOpsPage
